import type Coupon from '@app/interface/coupon/coupon.interface';
import { AutoApplyCouponType } from '@app/interface/content/auto-apply-coupon-type.enum';

export const isAutoApplyCoupon = (coupon?: Coupon) => {
  if (!coupon) return false;

  const { couponCode, autoApplyType } = coupon;

  if (!couponCode) return false;

  return Boolean(autoApplyType) && autoApplyType !== AutoApplyCouponType.FAMILY_DISCOUNT;
};
